const body = $("body");

$(document).ready(function() {
    let win = $(window);
    let docH = $(document).height();
    let winH = $(window).height();
    let but = $(".js-scroll-up, .post-edit-link, .cookies-settings");
    let lastScroll = 0;

    win.scroll(function () {

        let st = win.scrollTop()
        let botPos = docH - winH - st;

        // console.log(st);

        if (st > lastScroll){
            but.removeClass('show')
        } else {

            if(!body.hasClass("show-mobile-filter")) {
                but.addClass('show');
            }
        }

        lastScroll = st;

        if (lastScroll == 0) {
            but.removeClass('show')
        }

    });

});

$(document).on("click tap", ".js-scroll-up", function() {

    console.log("scroll up");

    $("html, body").animate({
        scrollTop: 0
    }, 350);
});
